import { gql } from '@apollo/client'

const GET_ALL_COMPANY = gql`
  query Companies($filter: CompanyFilter, $first: Int, $offset: Int) {
    companies(
      filter: $filter
      first: $first
      offset: $offset
      orderBy: NAME_ASC
    ) {
      nodes {
        id
        name
        siret
        tvaNumber
      }
    }
  }
`
export default GET_ALL_COMPANY
